import { Acquirer } from "../interfaces/acquirer";
import { Customer } from "../interfaces/customer";
import { CustomerAciquirerPaymentMethod } from "../interfaces/customerAcquirer";

export const findAcquirer = (
    customer: Customer,
    paymentMethod: CustomerAciquirerPaymentMethod
): Acquirer | undefined => {
    return customer.acquirers.find(
        (item) => item.customer_acquirer?.payment_method === paymentMethod
    );
};
